import { Grid, GridItem } from '../../../../components/index.js'
import ProductGallery from './ProductGallery/index.js'
import ProductDetail from './ProductDetail/index.js'
import ProductSummary from './ProductSummary/index.js'

const ProductCard = () => {
  return (
    <div id="ipc-product-card" className="laptop-md:pt-6 laptop-md:px-16 lg-desktop:px-[calc(50%-832px)]">
      <Grid className="laptop:gap-6">
        <GridItem className="tablet:px-8 laptop:px-16 laptop-md:px-0 laptop-md:col-start-1 laptop-md:col-span-8 laptop-md:sticky laptop-md:top-[124px] col-span-12 h-fit">
          <ProductGallery />
        </GridItem>
        <GridItem className="laptop-md:col-start-9 laptop-md:col-span-4 col-span-12">
          <ProductDetail />
        </GridItem>
      </Grid>
      <ProductSummary />
    </div>
  )
}

export default ProductCard
